
import React, { useState } from 'react';
import ModelParametersCard from './components/ModelParametersCard';
import ForecastResultsCard from './components/ForecastResultsCard';
import ScenarioComparisonCard from './components/ScenarioComparisonCard';
import { defaultCashflowResults } from './data/forecastingData';

const CashflowModels = () => {
  const [scenarioType, setScenarioType] = useState("baseline");
  const [stressLevel, setStressLevel] = useState([25]);
  const [includeContingent, setIncludeContingent] = useState(true);
  const [includeUndrawn, setIncludeUndrawn] = useState(true);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <ModelParametersCard 
          scenarioType={scenarioType}
          setScenarioType={setScenarioType}
          stressLevel={stressLevel}
          setStressLevel={setStressLevel}
          includeContingent={includeContingent}
          setIncludeContingent={setIncludeContingent}
          includeUndrawn={includeUndrawn}
          setIncludeUndrawn={setIncludeUndrawn}
        />
        <ForecastResultsCard />
      </div>
      
      <ScenarioComparisonCard results={defaultCashflowResults} />
    </div>
  );
};

export default CashflowModels;
